<template>
  <div id="personCertificate">
    <a-form
      ref="step8Ref"
      class="ant-round-form material-person-certificate-form"
      layout="vertical"
      :model="modelForm"
      @finish="submit"
    >
      <a-form-item name="customer" :label="$t('pages_merchant_009')">
        <div class="explain">
          {{ customerIdentity.includes('0') ? $t('pages_merchant_025') : $t('pages_merchant_065') }}
          <div style="margin-top: 12px">
            <a-tooltip :title="$t('pages_merchant_067')"><a>{{ $t('pages_merchant_066') }}</a></a-tooltip>
          </div>
          <div style="margin-top: 5px">
            <a-tooltip :title="$t('pages_merchant_069')"><a>{{ $t('pages_merchant_068') }}</a></a-tooltip>
          </div>
        </div>
        <div class="header-title">{{ $t('pages_merchant_070') }}</div>
        <div
          v-for="(item, index) in modelForm.customer"
          :key="index"
          class="certificate-area"
          :class="index !== modelForm.customer.length - 1 ? ' border-split' : ''"
        >
          <a-form-item
            :name="['customer', index, 'nationality']"
            :label="$t('pages_merchant_071')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-select
              v-model:value="item.nationality"
              show-search
              size="large"
              option-filter-prop="label"
              :placeholder="$t('common_text_005') + $t('pages_merchant_071')"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
              @change="e => countryChange(e, 'customer', index)"
            >
              <a-select-option
                v-for="country in countries"
                :key="country.areaCode"
                :value="country.areaCode"
                :label="language === 'zh' ? country.areaChineseName : country.areaEnglishName"
              >{{ language === 'zh' ? country.areaChineseName : country.areaEnglishName }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :name="['customer', index, 'certificateType']"
            :label="$t('pages_merchant_072')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-radio-group v-model:value="item.certificateType" :disabled="refused ? !refuseAttrs.includes('customer') : false" button-style="solid" @change="e => radioChange(e.target.value, 'customer', index)">
              <a-radio-button :disabled="!['CN', 'HK'].includes(item.nationality)" value="0" class="radio-area">{{ $t('pages_merchant_073') }}</a-radio-button>
              <a-radio-button value="1" class="radio-area">{{ $t('pages_merchant_074') }}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <!-- name input -->
          <a-form-item
            :name="['customer', index, 'name']"
            :label="$t('pages_merchant2_027')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.name"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
            />
          </a-form-item>
          <!-- birthday -->
          <a-form-item
            :name="['customer', index, 'birthDate']"
            :label="$t('pages_merchant2_028')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.birthDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- id no -->
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['customer', index, 'idNumber']"
            :label="$t('pages_merchant2_029')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.idNumber"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '1'"
            :name="['customer', index, 'passportNumber']"
            :label="$t('pages_merchant2_029_0')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.passportNumber"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
            />
          </a-form-item>
          <!-- issue date -->
          <a-form-item
            :name="['customer', index, 'certificateIssueDate']"
            :label="$t('pages_merchant2_030')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.certificateIssueDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- expiry date -->
          <a-form-item
            :name="['customer', index, 'certificateDate']"
            :label="$t('pages_merchant2_031')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.certificateDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item
            v-if="customerIdentity.includes('2')"
            :name="['customer', index, 'holdingRatio']"
            :label="$t('pages_merchant2_056')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.holdingRatio"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['customer', index, 'idPicFrontPath']"
            :label="$t('pages_merchant2_053')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.idPicFrontPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadCFRef' + index"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_053')"
              :max-count="1"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['customer', index, 'idPicBackPath']"
            :label="$t('pages_merchant2_053_0')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.idPicBackPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadCBRef' + index"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_053_0')"
              :max-count="1"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '1'"
            :label="$t('pages_merchant2_054')"
            :name="['customer', index, 'passportPicPath']"
            :rules="{ required: true, message: $t('common_text_007') + $t('pages_merchant_074') }"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.passportPicPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadCPRef' + index"
              :disabled="refused ? !refuseAttrs.includes('customer') : false"
              :explain="$t('common_text_007') + $t('pages_merchant_074')"
              :max-count="1"
            />
          </a-form-item>
          <!-- 公司国家为菲律宾、英属维尔京群岛、开曼群岛 需要地址证明 -->
          <a-form-item
            v-if="['PH', 'VG', 'KY'].includes(item.nationality) && (customerIdentity.includes('0') || customerIdentity.includes('1'))"
            :name="['customer', index, 'addressProofPath']"
            :label="$t('pages_merchant2_032')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.addressProofPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadCARef' + index"
              :disabled="refused ? !refuseAttrs.includes('director') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_032')"
              :max-count="5"
            />
          </a-form-item>
        </div>
        <div v-if="refused && refuseAttrs.includes('customer')" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.customerMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item v-if="countryCode === 'CN'" name="legalPerson">
        <div class="header-title">{{ $t('pages_merchant_054') }}</div>
        <div
          v-for="(item, index) in modelForm.legalPerson"
          :key="index"
          class="certificate-area"
          :class="index !== modelForm.legalPerson.length - 1 ? ' border-split' : ''"
        >
          <a-form-item
            :name="['legalPerson', index, 'nationality']"
            :label="$t('pages_merchant_071')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-select
              v-model:value="item.nationality"
              show-search
              size="large"
              option-filter-prop="label"
              :placeholder="$t('common_text_005') + $t('pages_merchant_071')"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
              @change="e => countryChange(e, 'legalPerson', index)"
            >
              <a-select-option
                v-for="country in countries"
                :key="country.areaCode"
                :value="country.areaCode"
                :label="language === 'zh' ? country.areaChineseName : country.areaEnglishName"
              >{{ language === 'zh' ? country.areaChineseName : country.areaEnglishName }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :name="['legalPerson', index, 'certificateType']"
            :label="$t('pages_merchant_072')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-radio-group v-model:value="item.certificateType" :disabled="refused ? !refuseAttrs.includes('legalPerson') : false" button-style="solid" @change="e => radioChange(e.target.value, 'legalPerson', index)">
              <a-radio-button :disabled="!['CN', 'HK'].includes(item.nationality)" value="0" class="radio-area">{{ $t('pages_merchant_073') }}</a-radio-button>
              <a-radio-button value="1" class="radio-area">{{ $t('pages_merchant_074') }}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <!-- name input -->
          <a-form-item
            :name="['legalPerson', index, 'name']"
            :label="$t('pages_merchant2_027')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.name"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
            />
          </a-form-item>
          <!-- birthday -->
          <a-form-item
            :name="['legalPerson', index, 'birthDate']"
            :label="$t('pages_merchant2_028')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.birthDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- id no -->
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['legalPerson', index, 'idNumber']"
            :label="$t('pages_merchant2_029')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.idNumber"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '1'"
            :name="['legalPerson', index, 'passportNumber']"
            :label="$t('pages_merchant2_029_0')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.passportNumber"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
            />
          </a-form-item>
          <!-- issue date -->
          <a-form-item
            :name="['legalPerson', index, 'certificateIssueDate']"
            :label="$t('pages_merchant2_030')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.certificateIssueDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- expiry date -->
          <a-form-item
            :name="['legalPerson', index, 'certificateDate']"
            :label="$t('pages_merchant2_031')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.certificateDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['legalPerson', index, 'idPicFrontPath']"
            :label="$t('pages_merchant2_053')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.idPicFrontPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadLFRef' + index"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_053')"
              :max-count="1"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['legalPerson', index, 'idPicBackPath']"
            :label="$t('pages_merchant2_053_0')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.idPicBackPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadLBRef' + index"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_053_0')"
              :max-count="1"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '1'"
            :label="$t('pages_merchant2_054')"
            :name="['legalPerson', index, 'passportPicPath']"
            :rules="{ required: true, message: $t('common_text_007') + $t('pages_merchant_074') }"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.passportPicPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadLPRef' + index"
              :disabled="refused ? !refuseAttrs.includes('legalPerson') : false"
              :explain="$t('common_text_007') + $t('pages_merchant_074')"
              :max-count="1"
            />
          </a-form-item>
          <div v-if="(refused && refuseAttrs.includes('legalPerson')) || (!refused && !false)" class="edit-area">
            <plus-circle-filled v-if="index === 0" class="ic-add" @click="handleEdit('legalPerson')" />
            <minus-circle-filled v-else class="ic-delete" @click="handleEdit('legalPerson', index)" />
          </div>
        </div>
        <div v-if="refused && refuseAttrs.includes('legalPerson')" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.legalPersonMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item v-else name="directorPerson">
        <div class="header-title">{{ $t('pages_merchant_056') }}</div>
        <div
          v-for="(item, index) in modelForm.directorPerson"
          :key="index"
          class="certificate-area"
          :class="index !== modelForm.directorPerson.length - 1 ? ' border-split' : ''"
        >
          <a-form-item
            :name="['directorPerson', index, 'nationality']"
            :label="$t('pages_merchant_071')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-select
              v-model:value="item.nationality"
              show-search
              size="large"
              option-filter-prop="label"
              :placeholder="$t('common_text_005') + $t('pages_merchant_071')"
              :disabled="refused ? !refuseAttrs.includes('director') : false"
              @change="e => countryChange(e, 'directorPerson', index)"
            >
              <a-select-option
                v-for="country in countries"
                :key="country.areaCode"
                :value="country.areaCode"
                :label="language === 'zh' ? country.areaChineseName : country.areaEnglishName"
              >{{ language === 'zh' ? country.areaChineseName : country.areaEnglishName }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :name="['directorPerson', index, 'certificateType']"
            :label="$t('pages_merchant_072')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-radio-group v-model:value="item.certificateType" :disabled="refused ? !refuseAttrs.includes('director') : false" button-style="solid" @change="e => radioChange(e.target.value, 'directorPerson', index)">
              <a-radio-button :disabled="!['CN', 'HK'].includes(item.nationality)" value="0" class="radio-area">{{ $t('pages_merchant_073') }}</a-radio-button>
              <a-radio-button value="1" class="radio-area">{{ $t('pages_merchant_074') }}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <!-- name input -->
          <a-form-item
            :name="['directorPerson', index, 'name']"
            :label="$t('pages_merchant2_027')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.name"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('directorPerson') : false"
            />
          </a-form-item>
          <!-- birthday -->
          <a-form-item
            :name="['directorPerson', index, 'birthDate']"
            :label="$t('pages_merchant2_028')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.birthDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('directorPerson') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- id no -->
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['directorPerson', index, 'idNumber']"
            :label="$t('pages_merchant2_029')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.idNumber"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('directorPerson') : false"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '1'"
            :name="['directorPerson', index, 'passportNumber']"
            :label="$t('pages_merchant2_029_0')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.passportNumber"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('directorPerson') : false"
            />
          </a-form-item>
          <!-- issue date -->
          <a-form-item
            :name="['directorPerson', index, 'certificateIssueDate']"
            :label="$t('pages_merchant2_030')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.certificateIssueDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('directorPerson') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- expiry date -->
          <a-form-item
            :name="['directorPerson', index, 'certificateDate']"
            :label="$t('pages_merchant2_031')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.certificateDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('directorPerson') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['directorPerson', index, 'idPicFrontPath']"
            :label="$t('pages_merchant2_053')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.idPicFrontPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadDFRef' + index"
              :disabled="refused ? !refuseAttrs.includes('director') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_053')"
              :max-count="2"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['directorPerson', index, 'idPicBackPath']"
            :label="$t('pages_merchant2_053_0')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.idPicBackPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadDBRef' + index"
              :disabled="refused ? !refuseAttrs.includes('director') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_053_0')"
              :max-count="2"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '1'"
            :label="$t('pages_merchant2_054')"
            :name="['directorPerson', index, 'passportPicPath']"
            :rules="{ required: true, message: $t('common_text_007') + $t('pages_merchant_074') }"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.passportPicPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadDPRef' + index"
              :disabled="refused ? !refuseAttrs.includes('director') : false"
              :explain="$t('common_text_007') + $t('pages_merchant_074')"
              :max-count="1"
            />
          </a-form-item>
          <!-- 公司国家为菲律宾、英属维尔京群岛、开曼群岛 需要地址证明 -->
          <a-form-item
            v-if="['PH', 'VG', 'KY'].includes(item.nationality)"
            :name="['directorPerson', index, 'addressProofPath']"
            :label="$t('pages_merchant2_032')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.addressProofPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadDARef' + index"
              :disabled="refused ? !refuseAttrs.includes('director') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_032')"
              :max-count="5"
            />
          </a-form-item>
          <div v-if="(refused && refuseAttrs.includes('director')) || (!refused && !false)" class="edit-area">
            <plus-circle-filled v-if="index === 0" class="ic-add" @click="handleEdit('directorPerson')" />
            <minus-circle-filled v-else class="ic-delete" @click="handleEdit('directorPerson', index)" />
          </div>
        </div>
        <div v-if="refused && refuseAttrs.includes('director')" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.directorPersonMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item name="shareholder">
        <div class="header-title">{{ $t('pages_merchant_078') }}</div>
        <div
          v-for="(item, index) in modelForm.shareholder"
          :key="index"
          class="certificate-area"
          :class="index !== modelForm.shareholder.length - 1 ? ' border-split' : ''"
        >
          <a-form-item
            :name="['shareholder', index, 'nationality']"
            :label="$t('pages_merchant_071')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-select
              v-model:value="item.nationality"
              show-search
              size="large"
              option-filter-prop="label"
              :placeholder="$t('common_text_005') + $t('pages_merchant_071')"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
              @change="e => countryChange(e, 'shareholder', index)"
            >
              <a-select-option
                v-for="country in countries"
                :key="country.areaCode"
                :value="country.areaCode"
                :label="language === 'zh' ? country.areaChineseName : country.areaEnglishName"
              >{{ language === 'zh' ? country.areaChineseName : country.areaEnglishName }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :name="['shareholder', index, 'certificateType']"
            :label="$t('pages_merchant_072')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-radio-group v-model:value="item.certificateType" :disabled="refused ? !refuseAttrs.includes('shareholder') : false" button-style="solid" @change="e => radioChange(e.target.value, 'shareholder', index)">
              <a-radio-button :disabled="!['CN', 'HK'].includes(item.nationality)" value="0" class="radio-area">{{ $t('pages_merchant_073') }}</a-radio-button>
              <a-radio-button value="1" class="radio-area">{{ $t('pages_merchant_074') }}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <!-- name input -->
          <a-form-item
            :name="['shareholder', index, 'name']"
            :label="$t('pages_merchant2_027')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.name"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
            />
          </a-form-item>
          <!-- birthday -->
          <a-form-item
            :name="['shareholder', index, 'birthDate']"
            :label="$t('pages_merchant2_028')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.birthDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- id no -->
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['shareholder', index, 'idNumber']"
            :label="$t('pages_merchant2_029')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.idNumber"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '1'"
            :name="['shareholder', index, 'passportNumber']"
            :label="$t('pages_merchant2_029_0')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.passportNumber"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
            />
          </a-form-item>
          <!-- issue date -->
          <a-form-item
            :name="['shareholder', index, 'certificateIssueDate']"
            :label="$t('pages_merchant2_030')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.certificateIssueDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- expiry date -->
          <a-form-item
            :name="['shareholder', index, 'certificateDate']"
            :label="$t('pages_merchant2_031')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-date-picker
              v-model:value="item.certificateDate"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
              value-format="YYYY-MM-DD"
            />
          </a-form-item>
          <!-- 持股比例 -->
          <a-form-item
            :name="['shareholder', index, 'holdingRatio']"
            :label="$t('pages_merchant2_056')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <a-input
              v-model:value="item.holdingRatio"
              size="large"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['shareholder', index, 'idPicFrontPath']"
            :label="$t('pages_merchant2_053')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.idPicFrontPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadSFRef' + index"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_053')"
              :max-count="2"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '0'"
            :name="['shareholder', index, 'idPicBackPath']"
            :label="$t('pages_merchant2_053_0')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.idPicBackPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadSBRef' + index"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_053_0')"
              :max-count="2"
            />
          </a-form-item>
          <a-form-item
            v-if="item.certificateType === '1'"
            :label="$t('pages_merchant2_054')"
            :name="['shareholder', index, 'passportPicPath']"
            :rules="{ required: true, message: $t('common_text_007') + $t('pages_merchant_074') }"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.passportPicPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadSPRef' + index"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
              :explain="$t('common_text_007') + $t('pages_merchant_074')"
              :max-count="1"
            />
          </a-form-item>
          <!-- 证件国家为菲律宾、英属维尔京群岛、开曼群岛 需要地址证明 -->
          <a-form-item
            v-if="['PH', 'VG', 'KY'].includes(item.nationality)"
            :name="['shareholder', index, 'addressProofPath']"
            :label="$t('pages_merchant2_032')"
            :rules="{ required: true }"
            style="margin-bottom: 12px"
          >
            <upload-auto
              :ref="getUploadRef"
              v-model:file-content="item.addressProofPath"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
              type="INVITE"
              list-type="picture"
              back-type="array"
              :name-index="'uploadSARef' + index"
              :disabled="refused ? !refuseAttrs.includes('shareholder') : false"
              :explain="$t('common_text_007') + $t('pages_merchant2_032')"
              :max-count="5"
            />
          </a-form-item>
          <div v-if="(refused && refuseAttrs.includes('shareholder')) || (!refused && !false)" class="edit-area">
            <plus-circle-filled v-if="index === 0" class="ic-add" @click="handleEdit('shareholder')" />
            <minus-circle-filled v-else class="ic-delete" @click="handleEdit('shareholder', index)" />
          </div>
        </div>
        <div v-if="refused && refuseAttrs.includes('shareholder')" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.shareholderMessage }}</span>
        </div>
      </a-form-item>

      <!-- 证件国家为菲律宾、英属维尔京群岛、开曼群岛 需要地址证明 -->
      <a-form-item
        :name="directorAddressProofPath"
        :label="$t('pages_merchant2_032')"
        :rules="{ required: false }"
      >
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant2_066') }}</span>
        </div>
        <upload-auto
          ref="uploadDirectorAddressProofPathRef"
          v-model:file-content="modelForm.directorAddressProofPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.directorAddressProofPathDisabled"
          :explain="$t('common_text_007') + $t('pages_merchant2_032')"
          :max-count="5"
        />
        <div v-if="refused && refuseAttrs.includes('directorAddressProofPath')" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.directorAddressProofPathMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item style="text-align: right; margin-top: 48px">
        <a-button
          type="primary"
          shape="round"
          ghost
          style="min-width: 138px; margin-right: 24px"
          @click="before()"
        >{{ $t('pages_merchant_040') }}</a-button>
        <a-button
          html-type="submit"
          type="primary"
          shape="round"
          style="min-width: 138px"
        >{{ $t('pages_merchant_020') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, nextTick, watch, onUnmounted } from 'vue'
import UploadAuto from '@/components/upload-auto'
export default {
  name: 'PersonCertificate',
  components: {
    'upload-auto': UploadAuto
  },
  props: {
    model: {
      type: Object,
      default: () => { return {} }
    },
    refused: {
      type: Boolean,
      default: () => { return false }
    },
    countryCode: {
      type: String,
      default: () => { return '' }
    },
    customerIdentity: {
      type: Array,
      default: () => { return [] }
    },
    countries: {
      type: Array,
      default: () => { return [] }
    },
    refuseAttrs: {
      type: Array,
      default: () => { return [] }
    }
  },
  setup (props, ctx) {
    const step8Ref = ref(null)
    const uploadDirectorAddressProofPathRef = ref(null)

    const state = reactive({
      language: localStorage.getItem('locale-language') || 'zh',
      rules: {
        customer: [{ required: true }]
      }
      // modelForm: {} // 初始为空对象
    })

    // state.modelForm = computed(() => {
    //   return props.model
    // })

    onUnmounted(() => {
      // clear()
    })

    watch(
      () => props.model,
      (newVal) => {
        if (newVal) {
          // 深拷贝以避免直接引用
          state.modelForm = JSON.parse(JSON.stringify(newVal))
          console.log('state.modelForm update:', state.modelForm)
        }
      },
      { immediate: true, deep: true }
    )

    // 使用 ref 存储上一次的值，便于比较
    // const previousCustomerData = ref(null)

    watch(
      () => state.modelForm?.customer?.[0],
      (customerData) => {
        console.log('customerData watch:', customerData, props.refused)
        if (!customerData || props.refused) return

        // 创建当前数据的深拷贝
        // const currentDataJSON = JSON.stringify(customerData)
        // const previousDataJSON = previousCustomerData.value
        //   ? JSON.stringify(previousCustomerData.value)
        //   : null

        // 仅当真正变化时处理
        // if (previousDataJSON !== currentDataJSON) {
        nextTick(() => {
          updateRelatedPeople(customerData)
        })

        // 更新之前的值
        // previousCustomerData.value = JSON.parse(currentDataJSON)
        // }
      },
      { immediate: true, deep: true }
    )

    const updateRelatedPeople = (customerData) => {
      console.log('updateRelatedPeople', customerData)
      state.modelForm.legalPerson[0].collDisable = false
      state.modelForm.directorPerson[0].collDisable = false
      state.modelForm.shareholder[0].collDisable = false

      const { certificateType, idPicFrontPath, idPicBackPath, passportPicPath, addressProofPath } = customerData

      if (props.customerIdentity.includes('0')) {
        state.modelForm.legalPerson[0] = Object.assign({}, customerData, {})
        if (certificateType === '0') {
          if (state.uploadLFRef0) state.uploadLFRef0.fileListRefresh(idPicFrontPath)
          if (state.uploadLBRef0) state.uploadLBRef0.fileListRefresh(idPicBackPath)
        }
        if (certificateType === '1') {
          if (state.uploadLPRef0) state.uploadLPRef0.fileListRefresh(passportPicPath)
        }
        // if (addressProofPath && addressProofPath.length > 0) {
        //   if (state.uploadLARef0) state.uploadLARef0.fileListRefresh(addressProofPath)
        // }
      }
      if (props.customerIdentity.includes('1')) {
        state.modelForm.directorPerson[0] = Object.assign({}, customerData, {})

        if (certificateType === '0') {
          if (state.uploadDFRef0) state.uploadDFRef0.fileListRefresh(idPicFrontPath)
          if (state.uploadDBRef0) state.uploadDBRef0.fileListRefresh(idPicBackPath)
        }
        if (certificateType === '1') {
          if (state.uploadDPRef0) state.uploadDPRef0.fileListRefresh(passportPicPath)
        }
        if (addressProofPath && addressProofPath.length > 0 && state.uploadDARef0) {
          state.uploadDARef0.fileListRefresh(addressProofPath)
        }
      }
      if (props.customerIdentity.includes('2')) {
        state.modelForm.shareholder[0] = Object.assign({}, customerData, {})

        if (certificateType === '0') {
          if (state.uploadSFRef0) state.uploadSFRef0.fileListRefresh(idPicFrontPath)
          if (state.uploadSBRef0) state.uploadSBRef0.fileListRefresh(idPicBackPath)
        }
        if (certificateType === '1') {
          if (state.uploadSPRef0) state.uploadSPRef0.fileListRefresh(passportPicPath)
        }
        if (addressProofPath && addressProofPath.length > 0 && state.uploadSARef0) {
          state.uploadSARef0.fileListRefresh(addressProofPath)
        }
      }
    }

    const getUploadRef = (el) => {
      if (el) state[el.nameIndex] = el
    }

    const radioChange = (e, attr, index) => {
      nextTick(() => {
        loadPath(e, attr, index)
        if (attr === 'customer' && !props.refused) {
          if (props.customerIdentity.includes('0')) loadPath(e, 'legalPerson', index)
          if (props.customerIdentity.includes('1')) loadPath(e, 'directorPerson', index)
          if (props.customerIdentity.includes('2')) loadPath(e, 'shareholder', index)
        }
      })
    }

    const countryChange = (e, attr, index) => {
      if (['HK', 'CN'].includes(e)) {
        state.modelForm[attr][index].certificateType = ''
      } else {
        state.modelForm[attr][index].certificateType = '1'
      }
    }

    const handleEdit = (attr, currentIndex) => {
      if (currentIndex) {
        state.modelForm[attr] = state.modelForm[attr].filter((item, index) => index !== currentIndex)
      } else {
        state.modelForm[attr].push({
          collDisable: false,
          certificateType: '',
          nationality: '',
          idNumber: '',
          passportNumber: '',
          name: '',
          birthDate: '',
          certificateIssueDate: '',
          certificateDate: '',
          holdingRatio: '',
          idPicFrontPath: [],
          idPicBackPath: [],
          passportPicPath: [],
          addressProofPath: []
        })
      }
    }

    const before = () => {
      ctx.emit('next', '2-3')
    }

    const submit = () => {
      console.log('personal submit:', state.modelForm)
      ctx.emit('update:model', state.modelForm)
      ctx.emit('next', '2-5')
    }

    // const clear = () => {
    //   const attrs = ['customer', 'legalPerson', 'directorPerson', 'shareholder']
    //   for (const attr of attrs) {
    //     for (const item of state.modelForm[attr]) {
    //       // if (item.certificateType === '0') {
    //       //   item.passport = []
    //       // }
    //       // if (item.certificateType === '1') {
    //       //   item.cert1 = []
    //       //   item.cert2 = []
    //       // }
    //       item.idPicFrontPath = []
    //       item.idPicBackPath = []
    //       item.passportPicPath = []
    //       item.addressProofPath = []
    //     }
    //   }
    // }

    nextTick(() => {
      const attrs = ['customer', 'legalPerson', 'directorPerson', 'shareholder']
      for (const item of attrs) {
        for (let index = 0; index < state.modelForm[item].length; index++) {
          loadPath(state.modelForm[item][index].certificateType, item, index)
        }
      }
      if (uploadDirectorAddressProofPathRef && uploadDirectorAddressProofPathRef.value && state.modelForm.directorAddressProofPath && state.modelForm.directorAddressProofPath.length > 0) {
        uploadDirectorAddressProofPathRef.value.fileListRefresh(state.modelForm.directorAddressProofPath)
      }
    })

    const loadPath = (type, attr, index) => {
      const ref = attr === 'customer' ? 'uploadC' : attr === 'legalPerson' ? 'uploadL' : attr === 'directorPerson' ? 'uploadD' : 'uploadS'
      console.log('ref attr index :', ref, attr, index)

      if (type === '0' && state[`${ref}FRef${index}`] && state.modelForm[attr][index].idPicFrontPath.length !== 0) {
        console.log('refresh front')
        state[`${ref}FRef${index}`].fileListRefresh(state.modelForm[attr][index].idPicFrontPath)
      }
      if (type === '0' && state[`${ref}BRef${index}`] && state.modelForm[attr][index].idPicBackPath.length !== 0) {
        console.log('refresh back')
        state[`${ref}BRef${index}`].fileListRefresh(state.modelForm[attr][index].idPicBackPath)
      }
      if (type === '1' && state[`${ref}PRef${index}`] && state.modelForm[attr][index].passportPicPath.length !== 0) {
        console.log('refresh passport')
        state[`${ref}PRef${index}`].fileListRefresh(state.modelForm[attr][index].passportPicPath)
      }

      if (state[`${ref}ARef${index}`] && state.modelForm[attr][index].addressProofPath.length !== 0) {
        console.log('refresh address')
        state[`${ref}ARef${index}`].fileListRefresh(state.modelForm[attr][index].addressProofPath)
      }
    }

    const checkLegalBirthday = (rule, value) => {
      console.log('checkLegalBirthday', rule, value, state.modelForm.legalPerson)
      if (value) {
        const birthDate = new Date(value)
        const now = new Date()
        const age = now.getFullYear() - birthDate.getFullYear()
        if (age < 18) {
          return Promise.reject($t('pages_merchant2_057'))
        }
      }
      return Promise.resolve()
    }

    return {
      step8Ref,
      before,
      submit,
      handleEdit,
      radioChange,
      checkLegalBirthday,
      countryChange,
      getUploadRef,
      updateRelatedPeople,
      uploadDirectorAddressProofPathRef,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#personCertificate {
  .header-img {
    margin-bottom: 36px;
    img {
      width: 200px;
    }
  }
  .material-person-certificate-form {
    .explain {
      color: #495060;
    }
    .header-title {
      font-size: 16px;
      font-weight: 500;
      margin-top: 24px;
    }
    .certificate-area {
      margin-top: 24px;
      padding: 0 12px 18px 12px;
      .radio-area {
        height: auto;
        min-width: 180px;
        text-align: center;
      }
      .edit-area {
        text-align: right;
        padding-right: 12px;
        margin-top: -6px;
        .ic-delete, .ic-add  {
          color: @main-color;
          cursor: pointer;
          font-size: 20px;
        }
      }
    }
    .border-split {
      border-bottom: 2px dashed #d9d9d9;
    }
    .certificate-area:deep(.ant-form-item-label) {
      label {
        font-size: 14px !important;
      }
    }
  }
}

</style>

